import $ from "cash-dom";
import { addFormToCart, addVariantToCart } from "../resources/shopify-cart";
import { cart } from "./cart";

$('[data-component="product-form"]').on("submit", function (e) {
	e.preventDefault();
	const addToCartButton = $(this).find('[data-element="add-to-cart-button"]');
	addToCartButton.attr("data-state", "adding");
	// Add form to cart
	addFormToCart(this).then(function (cartData) {
		cart.show(cartData);
		addToCartButton.attr("data-state", "");
	});
});

$(document.body).on("click", "[data-action-add-variant-to-cart]", function (e) {
	e.preventDefault();
	const variantId = $(this).attr("data-variant-id");

	// Add variant to cart
	addVariantToCart(variantId, 1).then(function (cartData) {
		cart.show(cartData);
	});
});
